<p-breadcrumb [model]="items" [home]="home" class="d-none d-md-block">
  <ng-template #item let-item>
    <ng-container *ngIf="item.route; else elseBlock">
      <a [routerLink]="item.route" [queryParams]="item.queryParams" class="p-breadcrumb-item-link fw-medium text-primary">
        <ng-container *ngIf="item.icon">
          <small [ngClass]="[item.icon ? item.icon : '']"></small>
        </ng-container>

        <ng-container *ngIf="item.label">
          <small class="text-uppercase text-truncate" [style]="{ 'max-width': '150px' }">{{ item.label }}</small>
        </ng-container>
      </a>
    </ng-container>
    <ng-template #elseBlock>
      <div class="p-breadcrumb-item-link fw-medium">
        <ng-container *ngIf="item.icon">
          <small [ngClass]="[item.icon ? item.icon : '']"></small>
        </ng-container>

        <ng-container *ngIf="item.label">
          <small class="text-uppercase text-truncate" [style]="{ 'max-width': '150px' }">{{ item.label }}</small>
        </ng-container>
      </div>
    </ng-template>
  </ng-template>
</p-breadcrumb>
